import React from 'react';
import { useTranslations } from './contexts/TranslationContext';

export default function ContentTabBar({ activeTab, onTabChange }) {
  var t = useTranslations();

  return (
    <div className="content-tab-bar">
      <button
        type="button"
        className={'content-tab-bar__tab' + (activeTab === 'id' ? ' content-tab-bar__tab--active' : '')}
        onClick={function() { onTabChange('id'); }}
      >
        {t.tab_indonesian}
      </button>
      <button
        type="button"
        className={'content-tab-bar__tab' + (activeTab === 'en' ? ' content-tab-bar__tab--active' : '')}
        onClick={function() { onTabChange('en'); }}
      >
        {t.tab_english}
      </button>
    </div>
  );
}
